<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M20 7V5a2 2 0 0 0-2-2H5a3 3 0 0 0-3 3v12c0 2.2 1.8 3 3 3h15a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2m-2 9h-2v-4h2zM5 7a1 1 0 0 1 0-2h13v2z"
    />
  </svg>
</template>
